<template>
  <button v-on="$listeners" class="d-flex align-center justify-center">
    <iconCross></iconCross>
  </button>
</template>

<script>
import iconCross from '@/assets/svg/cross-icon.svg'
export default {
  name: 'ButtonClose',
  components: {
    iconCross
  }
}
</script>

<style lang="scss" scoped>
button {
  position: fixed;
  right: 12px;
  top: 12px;
  z-index: 20;
  outline: none;
  width: 64px;
  height: 64px;
  border-radius: 64px;
  transition: transform 0.25s ease-out !important;

  @include breakpoint('sm-and-down') {
    width: 48px;
    height: 48px;
    border-radius: 48px;
  }

  &:hover {
    transform: rotate(180deg);
  }

  svg {
    width: 16px;
    height: 16px;
    fill: $c-black !important;
    stroke: $c-black !important;
    stroke-width: 2px;
  }
}
</style>
